import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import {useMainTranslation} from "../../../../../newShared/hooks/useMainTranslationHooks/useMainTranslation";
import {
    assetsDialogsSelector,
    certificateAssetsSettingsSelector,
    loadings,
    setCreateSettingRowDialogAction
} from "../../store/store";
import {useForm} from "../../../../../newShared/hooks/useForm";
import {
    PATH_LOCAL_ASSET_MANAGEMENT_CERTIFICATES,
    PATH_LOCAL_ASSET_MANAGEMENT_CERTIFICATES_ID,
    PATH_LOCAL_ASSET_MANAGEMENT_CERTIFICATES_NEW
} from "../../constants";
import {useSetBreadcrumbs} from "../../../../barsEnvironment/breadcrumbs/hooks/useBreadcrumbs";
import {PATH_LOCAL_ASSET_MANAGEMENT} from "../../../../../newShared/constants";
import {createCertificateAssetAction, getCertificateAssetsSettingsAction,} from "../../store/actions";
import {TCertificateAsset, TSetCreateSettingRowDialog} from "../../types";
import {toBase64} from "../../../../../newShared/utils/base64/base64";


export const useCertificateAssetNew = () => {
    //root
    const dispatch = useDispatch();
    const history = useHistory();
    const {t: tMenu} = useMainTranslation('', {keyPrefix: 'LeftMenu'});

    //selectors
    const {isLoadingSettings, isLoadingCreateAsset} = useSelector(loadings);
    const settings = useSelector(certificateAssetsSettingsSelector);
    const {createAsset: {isOpen: isOpenCreateAsset}} = useSelector(assetsDialogsSelector);


    const initialCertificateAsset: TCertificateAsset = {
        id: '',
        name: '',
        owner: '',
        fileId: '',
        fileName: '',
        renewal: '',
        customFields: {},
    }
    //form
    const {form, setForm, handleChange} = useForm<TCertificateAsset>(initialCertificateAsset);

    const [file, setFile] = useState<File | null>(null);
    const [fileName, setFileName] = useState<string>('');

    const handleDeleteFile = () => {
        setFileName('');
        setFile(null);
    }

    const ref = React.createRef<HTMLInputElement>();

    const filePicker = () => {
        ref.current && ref.current.click();
    };

    const fileHandler = (files: FileList | null) => {
        if(files && files?.length > 0){
            setFile(files[0]);
            setFileName(files[0].name)
        }
    };

    const controller = new AbortController();
    useEffect(() => {
        if(!settings) {
            dispatch(getCertificateAssetsSettingsAction({data: {organizationId: '', workspaceId: ''}, signal: controller.signal}));
        }
        if(settings && settings.customFields && Object.keys(settings.customFields).length){
            const customFields: { [key: string]: string } = {};
            Object.keys(settings.customFields).length && Object.keys(settings.customFields).forEach((key) => customFields[key] = '');
            setForm({...form, customFields});
        }
        setFile(null);
        setFileName('');

        return () => {
            controller.abort();
            setFile(null);
            setFileName('');
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if(settings && settings.customFields && Object.keys(settings.customFields).length){
            const customFields: { [key: string]: string } = {};
            Object.keys(settings.customFields).forEach((key) => customFields[key] = '');
            setForm({...form, customFields});
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [settings, settings?.customFields]);

    useEffect(() => {
        isOpenCreateAsset && setForm(initialCertificateAsset);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpenCreateAsset]);


    useSetBreadcrumbs([
        {
            title: tMenu('Asset Management'),
            path: PATH_LOCAL_ASSET_MANAGEMENT
        },
        {
            title: 'Certificates',
            path: PATH_LOCAL_ASSET_MANAGEMENT_CERTIFICATES
        },
        {
            title: tMenu('New asset'),
            path: PATH_LOCAL_ASSET_MANAGEMENT_CERTIFICATES_NEW
        },
    ]);

    //actions
    const handleGoBack = () => history.push(PATH_LOCAL_ASSET_MANAGEMENT_CERTIFICATES);

    // const isOkId = () => {
    //     return form.id.trim().length > 0 ? Boolean( form.id.match(/^[A-Za-z0-9-_]+$/)) : true;
    // }

    const handleSave = async() => {
        if (file && form.name.trim().length > 0){
            const fileBase64: string = await toBase64(file) as string;
            dispatch(createCertificateAssetAction({data: {workspaceId: '', organizationId: '', asset: {...form, fileName}, file: fileBase64,}, onSuccess}));
        }
    }

    const onSuccess = (id: string) => {
        history.push(PATH_LOCAL_ASSET_MANAGEMENT_CERTIFICATES_ID.replace(':id', id));
    }


    const handleSetRenewal = (title: string) => {
        setForm({...form, renewal: title});
    }

    // const handleSetManager = (newValue: string) => {
    //     setForm({...form, owner: newValue ? newValue : ''});
    // }

    const handleChangeCustomField = (event:React.ChangeEvent<HTMLInputElement>) => {
        event.persist();
        setForm((prevValues) => ({
            ...prevValues,
            customFields: {
                ...prevValues.customFields,
                [event.target.name]: event.target.value,
            },
        }));
    };

    //CreateAssetDialog
    const openCreateSettingRowDialog = (data: TSetCreateSettingRowDialog) => {dispatch(setCreateSettingRowDialogAction(data))};


    return {
        settings,
        form,
        handleChange,
        file,
        fileName,
        handleDeleteFile,
        ref,
        filePicker,
        fileHandler,

        handleSave,
        handleGoBack,
        onSuccess,
        handleChangeCustomField,
        handleSetRenewal,

        isLoadingSettings,
        isLoadingCreateAsset,

        createAssetDialog: {
            isOpenCreateAsset,
        },

        openCreateSettingRowDialog,
    }
}
